<template>
  <ModuleContainer v-bind="bindModule" :btnWidth="70">
    <template #btn>
      <MapControlGroupButton row>
        <button
          v-for="baseMap in c_baseMaps"
          :key="baseMap.id"
          class="px-2 py-1"
          @click="onClick(baseMap)"
          :class="{
            active: current_baseMaps && current_baseMaps.id == baseMap.id,
          }"
        >
          {{ baseMap.title }}
        </button>
      </MapControlGroupButton>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import { DraggablePopup } from '@components/draggable'
import MapControlButton from '@components/Map/control/MapControlButton.vue'
import MapControlGroupButton from '@components/Map/control/MapControlGroupButton.vue'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'

import defaultbasemap from './basemap'
import BaseMapMixin from './BaseMapStore.mixins'

export default {
  components: { MapControlGroupButton },
  mixins: [ModuleMixin, BaseMapMixin],
  props: {
    baseMaps: {
      type: Array,
      default: () => defaultbasemap,
    },
    title: {
      type: String,
      default: 'Bản đồ nền',
    },
    defaultBaseMap: {
      type: String,
      default: 'Streets',
    },
    controlIcon: {
      type: String,
      default: 'mdi mdi-layers-outline',
    },
  },
  data: () => ({ p_baseMaps: [], show: false }),
  watch: {
    baseMaps: {
      immediate: true,
      handler(value) {
        if (!value || value.length < 1) return
        this.p_baseMaps = value
      },
    },
    p_baseMaps: {
      immediate: true,
      handler(value) {
        if (!this.map || !value || value.length < 1) return
        this.onInit()
      },
    },
  },
  methods: {
    onInit() {
      if (this.p_baseMaps.length > 0) {
        this.setBaseMaps(this.p_baseMaps)
      }
    },
    onToggleList() {
      this.show = !this.show
    },
    onClick(item) {
      if (this.current_baseMaps && item.id === this.current_baseMaps.id) {
        return
      }
      this.loadItem(item)
    },
  },
}
</script>
<style scoped>
.base-map-button__title {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
}
.base-map-button__title > div {
  font-size: 0.6rem;
}
.base-map-button__container {
  padding: 2px;
}
.active {
  background-color: var(--v-primary-base);
  color: #fff;
  font-weight: bold;
}
</style>
